export default "__VITE_ASSET__Orp3qYPE__"